import { takeEvery, fork, put, all, call, select } from 'redux-saga/effects';

import { GET_SAVED_CAMPAIGNS } from './actionTypes';
import {
    getSavedCampaignsSuccess,
    getSavedCampaignsFailed
} from './actions';
import {noParamGet} from '../../../apiHelpers/commonApiHelper';
import toastr from 'toastr';

function* getSavedCam() {
    try {
        const response = yield call(noParamGet, '/api/v1/campaigns/saved_campaigns');
        if(response.status === 200) {
            yield put(getSavedCampaignsSuccess(JSON.parse(response.data.campaigns)));
        } else {
            yield put(getSavedCampaignsFailed());
        }

    } catch (error) {
        yield put(getSavedCampaignsFailed());
    }
}


export function* watchGetPlayer() {
    yield takeEvery(GET_SAVED_CAMPAIGNS, getSavedCam)
}

function* SavedCampaignSaga() {
    yield all([
        fork(watchGetPlayer)
    ]);
}

export default SavedCampaignSaga;